import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { CampaignsServiceProvider } from '../../api/campaigns'

const CampaignsService = CampaignsServiceProvider()
const name = 'sendEmailsCampaign'
/**
 * action - start/stop/continue/new
 * employees - true/false
 * employeeIds - [1, 2, 3]
**/

export default (action, employeeIds, emailTemplateId) => (asyncAction(
  name,
  CampaignsService.sendEmailsCampaign,
  { action, employeeIds, emailTemplateId }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/campaign/sendEmailsCampaign.js